import { render, staticRenderFns } from "./CreateCoursePage.vue?vue&type=template&id=1494ca8d"
import script from "./CreateCoursePage.vue?vue&type=script&lang=ts"
export * from "./CreateCoursePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports